import React from 'react';
import classNames from 'classnames';
import styles from './MiddleDotSeparator.css';

export default function MiddleDotSeparator({ className }) {
  return (
    <span className={classNames(styles.middleDotSeparator, className)}>·</span>
  );
}
